/**
 * Artifacts Translations - Spanish
 */

type ArtifactsLocale = typeof import('../en/artifacts').default

const artifacts = {
	title: 'Artefactos',
	addNew: 'Añadir artefacto',
	empty: 'Aún no hay artefactos',

	// Facet types
	highlights: {
		name: 'Puntos clave',
		description: 'Ideas principales de este tema',
	},
	deepDive: {
		name: 'Análisis profundo',
		description: 'Análisis extendido y contexto',
	},
	summary: {
		name: 'Resumen',
		description: 'Descripción breve del contenido',
	},
	quiz: {
		name: 'Cuestionario',
		description: 'Pon a prueba tu comprensión',
		empty: 'No hay cuestionario disponible',
		comingSoon: 'Cuestionario interactivo próximamente',
		explanation: 'Explicación',
	},
	notes: {
		name: 'Notas',
		description: 'Tus notas personales',
		placeholder: 'Empieza a escribir tus notas...',
		empty: 'Aún no hay notas',
		startWriting: 'Empezar a escribir',
		lastUpdated: 'Última actualización',
		saved: 'Notas guardadas correctamente',
	},
	diagram: {
		name: 'Diagrama',
		description: 'Representación visual',
		empty: 'No hay diagrama disponible',
		create: 'Crear diagrama',
		loading: 'Cargando diagrama…',
		preparing: 'Preparando visualización…',
		emptyMessage: 'Aún no hay un diagrama.',
		untitled: 'Sin título',
		nodeFallback: 'Nodo {{index}}',
		connectionType: {
			bezier: 'Bezier',
			smoothStep: 'Smooth',
		},
	},
	flashcards: {
		name: 'Tarjetas de estudio',
		description: 'Tarjetas para memorización',
	},
	routeCards: {
		name: 'Tarjetas',
		title: 'Tarjetas',
		deckLabel: 'Mazo de tarjetas',
		backToRoute: 'Volver a {{mainEntityArticleLower}} {{mainEntityLabelLower}}',
		factsLabel:
			'Datos clave {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
		reveal: 'Revelar',
		showFront: 'Ver concepto',
		empty:
			'Aún no hay tarjetas para {{mainEntityArticleLower}} {{mainEntityLabelLower}}.',
		generateErrorToast: {
			title: 'No pudimos generar las tarjetas',
			description: 'Ha habido un problema. Inténtalo de nuevo.',
		},
		modality: {
			review: 'Repaso',
			facts: 'Datos clave',
		},
	},
	keyConcepts: {
		name: 'Conceptos clave',
		description: 'Conceptos importantes a recordar',
	},

	summarizePost: {
		name: 'Resumen',
		description: 'Genera un resumen conciso',
	},
	highlightCriticalConcepts: {
		name: 'Conceptos críticos',
		description: 'Resalta y explica los conceptos más importantes',
	},
	offerPracticalExamples: {
		name: 'Ejemplos prácticos',
		description: 'Ofrece ejemplos prácticos para ilustrar el contenido',
	},
	recommendApplicationExercises: {
		name: 'Ejercicios de aplicación',
		description: 'Recomienda ejercicios para aplicar lo aprendido',
	},
	createActionPlan: {
		name: 'Plan de acción',
		description: 'Convierte el contenido en un plan de acción práctico',
	},

	// Content viewer
	content: {
		empty: 'No hay contenido disponible',
	},

	// Generic viewer
	generic: {
		type: 'Tipo',
		facet: 'Faceta',
		metadata: 'Metadatos',
		content: 'Contenido',
		noContent: 'No hay contenido disponible',
	},

	// Actions
	actions: {
		edit: 'Editar',
		delete: 'Eliminar',
		generate: 'Generar',
		save: 'Guardar',
		cancel: 'Cancelar',
		highlightSelection: 'Resaltar selección',
		generateHighlights: 'Generar puntos clave',
		generateQuiz: 'Generar cuestionario',
		addNotes: 'Añadir notas',
	},

	// Errors
	errors: {
		loadFailed: 'Error al cargar artefactos',
		saveFailed: 'Error al guardar artefacto',
		deleteFailed: 'Error al eliminar artefacto',
		generateFailed: 'Error al generar artefacto',
	},

	// Types for Config Studio multiselect
	types: {
		summary: 'Resumen',
		notes: 'Notas',
		flashcards: 'Tarjetas de estudio',
		diagram: 'Diagrama',
		keyConcepts: 'Conceptos clave',
	},

	// Dialog
	dialogTitle: 'Artefactos',
	dialogDescription: 'Ver y gestionar contenido generado para este tema',
	manage: 'Artefactos',
	manageTooltip: 'Crear y gestionar artefactos',
	noContent: 'No hay contenido para este tipo de artefacto',
} satisfies ArtifactsLocale

export default artifacts
